// Utility: map ISO 4217 numeric currency codes to symbols
// Minimal set per requirements; extend as needed.

export function getCurrencySymbolByCode(code?: number): string {
  switch (code) {
    case 643:
      return '₽'; // RUB
    case 840:
      return '$'; // USD
    case 51:
      return '֏';
    case 978:
      return '€'; // EUR
    // Add more as needed
    default:
      return '';
  }
}

export default getCurrencySymbolByCode;
